import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { Text, Title } from '@repo/foundations';
import { useUpdateIntegration, type IIntegration } from '../../../../../api';

interface SsrsPreferencesProps {
	integration: IIntegration;
}

export function SsrsPreferences({ integration }: SsrsPreferencesProps) {
	const { mutateAsync: updateIntegration } = useUpdateIntegration({});

	const includeHiddenResources =
		integration.credentials?.include_hidden_resources === true;

	const handleToggleHiddenResources = (checked: boolean) => {
		const credentials = {
			...(integration?.credentials ?? {}),
			include_hidden_resources: checked,
		};
		updateIntegration({
			data: { id: integration.id, credentials },
		});
	};

	return (
		<Stack spacing="md">
			<Stack spacing={0}>
				<Title size="md">SSRS Sync</Title>
				<Text size="sm" color="text/secondary/default">
					Configure how resources are synced from SSRS
				</Text>
			</Stack>
			<Box>
				<SettingsSwitch
					title="Include hidden resources"
					description="Import reports, datasets, and folders that are marked as hidden in SSRS. When disabled, only visible resources are synced."
					checked={includeHiddenResources}
					onChange={handleToggleHiddenResources}
				/>
			</Box>
		</Stack>
	);
}
